module.exports = __webpack_public_path__ + "img/download-alb.c1760b97.svg";